// @flow

import React from "react";

import options from "../utils/options";
import type { SchemaTableWidgetProps } from "../types";

const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = 3600;
const MAX_TIME_IN_SECONDS = 86400;

//TODO: Remove
export class HoursAndMinutesSelectWidget extends React.Component<SchemaTableWidgetProps<number>> {
  options = (limit: number): Array<{ title: string, const: number }> =>
    [...new Array(limit)].map((_: *, i: number) => ({
      title: `${i.toString().padStart(2, "0")}`,
      const: i,
    }));

  get hours() {
    return Math.floor(this.props.data / SECONDS_IN_HOUR);
  }

  get minutes() {
    return Math.floor(this.props.data / SECONDS_IN_MINUTE) - this.hours * SECONDS_IN_MINUTE;
  }

  hasUiSchemaError = (data: number): boolean => {
    return data === null || data === undefined || typeof data !== "number";
  };

  hasError = (value: number): boolean => {
    return !!this.props.error || this.hasUiSchemaError(value);
  };

  updateHours = (e: SyntheticEvent<HTMLInputElement>): void => {
    const val =
      parseInt(e.currentTarget.value) * SECONDS_IN_HOUR + this.minutes * SECONDS_IN_MINUTE;
    if (val > MAX_TIME_IN_SECONDS) return;
    this.props.onChange(val);
  };

  updateMinutes = (e: SyntheticEvent<HTMLInputElement>): void => {
    const val = this.hours * SECONDS_IN_HOUR + parseInt(e.currentTarget.value) * SECONDS_IN_MINUTE;
    if (val > MAX_TIME_IN_SECONDS) return;
    this.props.onChange(val);
  };

  render() {
    const disabled = options.resolveBoolean((this.props.options || {}).disabled, this.props.row);

    if (!this.props.active) {
      return (
        <div>
          `${this.hours}h ${this.minutes}m`
        </div>
      );
    }
    return (
      <div className={this.hasError(this.props.data) ? "error" : ""}>
        <input
          type="number"
          disabled={disabled}
          max={24}
          min={0}
          value={this.hours.toString().padStart(2, "0")}
          onChange={this.updateHours}
        />
        <input
          type="number"
          disabled={disabled}
          max={60}
          min={0}
          value={this.minutes.toString().padStart(2, "0")}
          onChange={this.updateMinutes}
        />
      </div>
    );
  }
}

export default HoursAndMinutesSelectWidget;
